// Texto de «Notion al dia»: cuanto hace de la ultima sincronizacion y que estado dar. Puro, sin React ni red.

// «hace un momento», «hace 12 min», «hace 3 h», «hace 2 días»
export function haceCuanto(iso, ahora = Date.now()) {
  const t = Date.parse(iso || "");
  if (!Number.isFinite(t)) return null;
  const min = Math.max(0, Math.floor((ahora - t) / 60000));
  if (min < 1) return "hace un momento";
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.floor(h / 24);
  return `hace ${d} ${d === 1 ? "día" : "días"}`;
}

// -> null (no mostrar nada) o { tipo: "ok"|"sync"|"aviso", simbolo, texto, detalle?, reconectar?, sincronizar }
export function estadoNotion(notion, ahora = Date.now()) {
  if (!notion || !notion.conectado) return null;
  const hace = haceCuanto(notion.ultima, ahora);
  if (notion.sincronizando) return { tipo: "sync", simbolo: "⟳", texto: "Sincronizando Notion…", sincronizar: false };
  if (notion.error) {
    const detalle = notion.error === "sesion" ? "Tu conexión con Notion ha caducado."
      : notion.error === "limite" ? "Notion pide esperar un poco."
      : "El último intento falló.";
    return { tipo: "aviso", simbolo: "⚠", texto: hace ? `Notion sin actualizar desde ${hace}` : "Notion sin sincronizar todavía",
             detalle, reconectar: notion.error === "sesion", sincronizar: notion.error !== "sesion" };
  }
  // «Aun no sincronizado» no es un fallo: neutro, sin el fondo de aviso
  return { tipo: "ok", simbolo: hace ? "✓" : "○",
           texto: hace ? `Notion al día, ${hace}` : "Notion aún no sincronizado", sincronizar: true };
}
